import {Component, Input} from '@angular/core';
import {SortDescriptor}   from '@progress/kendo-data-query';
import {ApKendoIconService} from '../../../../icons/ap-kendo-icon.service';

/**
 * the Sorting Control inspired by Kendo
 */
@Component({
  selector: 'ap-crop-rotation-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss']
})
export class SortComponent {
  protected readonly ApKendoIconService = ApKendoIconService;
  /**
   * the Sort Description
   */
  @Input() public sort: SortDescriptor[] = [];
  /**
   * the Field in the DataSource to Sort
   */
  @Input() public field = '';
}
